window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag('js', new Date());
gtag('config', 'G-WWD5WTEHY1');


window.googleanalyticsInterop = {

    // Sets the user-scoped 'role' property. This does NOT send a hit on its own -
    // GA only records the property once a subsequent event is sent.
    setUserRoleForGTag: async (role) =>
    {
        gtag('set', 'user_properties', {
            'role': role
        });
    },

    // Called when the visitor picks their audience in the welcome modal. Sets the
    // property and immediately sends an event so the selection reaches GA in the
    // same session, rather than waiting for the next page load.
    trackRoleSelection: async (role) =>
    {
        gtag('set', 'user_properties', {
            'role': role
        });

        gtag('event', 'role_selected', {
            'role': role
        });
    }

}
